__turbopack_context__.v({
  "add-to-cart": "add-to-cart-component-module-scss-module__SaFjzq__add-to-cart",
  "add-to-cart__actions": "add-to-cart-component-module-scss-module__SaFjzq__add-to-cart__actions",
  "add-to-cart__cart-button": "add-to-cart-component-module-scss-module__SaFjzq__add-to-cart__cart-button",
  "add-to-cart__cart-button-text": "add-to-cart-component-module-scss-module__SaFjzq__add-to-cart__cart-button-text",
  "add-to-cart__cart-button-wrapper": "add-to-cart-component-module-scss-module__SaFjzq__add-to-cart__cart-button-wrapper",
  "add-to-cart__info-icon": "add-to-cart-component-module-scss-module__SaFjzq__add-to-cart__info-icon",
  "add-to-cart__info-text": "add-to-cart-component-module-scss-module__SaFjzq__add-to-cart__info-text",
  "add-to-cart__quantity-wrapper": "add-to-cart-component-module-scss-module__SaFjzq__add-to-cart__quantity-wrapper",
  "add-to-cart__warning": "add-to-cart-component-module-scss-module__SaFjzq__add-to-cart__warning",
});
